export class Horimetro {
    static calcHorimetro (valor) {
        let resto = valor;

        if ( resto > 60 ) {
            let horas = Math.floor( resto / 60 );
            resto = resto - (60 * horas);

            return horas + 'h ' + (resto ?  resto + 'm' : '');
        }

        return resto + 'm';
    }
}
